import { AutomationFilter, DateTimeType, WhereType } from 'src/components/AutomationTrading/AutomationTrading';
import React from 'react';
import {
    FilterData,
    FilterKey,
    ItemsWrapper,
} from 'src/components/AutomationTrading/AutomationItem/AutomationItem.style';

export const renderDatetime = (item: DateTimeType): JSX.Element => {
    switch (item.kind) {
        case 'shift':
            return <>Shift: {item.shift}</>;
        case 'now':
            return <>Now</>;
        case 'dateAt':
            return (
                <>
                    {item.hour === undefined ? null : `Hour: ${item.hour}`}{' '}
                    {item.minute === undefined ? null : `Minute: ${item.minute}`}{' '}
                    {item.second === undefined ? null : `Second: ${item.second}`}
                </>
            );
    }
};

export const renderBetween = (item: AutomationFilter): JSX.Element | null => {
    if (item.kind !== 'between') {
        return null;
    }
    const between = item.between;
    return (
        <ItemsWrapper>
            <FilterKey>From:</FilterKey>
            <FilterData>{between.from.kind === 'datetime' ? renderDatetime(between.from.datetime) : null}</FilterData>
            <FilterKey>To:</FilterKey>
            <FilterData>{between.to.kind === 'datetime' ? renderDatetime(between.to.datetime) : null}</FilterData>
            <FilterData>{between.field}</FilterData>
        </ItemsWrapper>
    );
};

export const getFieldValue = (field: WhereType['value']): string => {
    switch (field.kind) {
        case 'datetime':
            if (field.datetime.kind === 'dateAt') {
                return `Data: ${JSON.stringify(field.datetime)}`;
            } else if (field.datetime.kind === 'now') {
                return 'Now';
            } else {
                return field.datetime.shift.toString();
            }
        case 'text':
            return field.text;
        case 'yesno':
            return JSON.stringify(field.yesno);
    }
};
